import * as React from 'react';
import * as styles from './styles.scss';
import { checkNetworkConnectionText } from './NetworkError.locstring.json';
import { getIsLightBaseTheme } from 'owa-theme';
import { observer } from 'mobx-react-lite';
import { PrimaryButton, DefaultButton } from '@fluentui/react/lib/Button';
import { retryButtonText } from 'owa-locstrings/lib/strings/retrybuttontext.locstring.json';
import { cancelButton } from 'owa-locstrings/lib/strings/cancelbutton.locstring.json';
import classNames from 'classnames';
import loc from 'owa-localize';

export default observer(function NetworkError({
    errorMessage,
    onRetry,
    onCancel,
}: {
    errorMessage?: string;
    onRetry?: () => void;
    onCancel?: () => void;
}) {
    const imageClassName = classNames(styles.networkErrorImage, {
        [styles.networkErrorImageColor]: getIsLightBaseTheme(),
    });

    return (
        <div className={styles.centered}>
            <div className={imageClassName} />
            <div className={styles.errorReport}>{errorMessage}</div>
            <div className={styles.checkNetworkConnection}>{loc(checkNetworkConnectionText)}</div>
            <div className={styles.buttons}>
                {onRetry && (
                    <PrimaryButton className={styles.button} onClick={onRetry}>
                        {loc(retryButtonText)}
                    </PrimaryButton>
                )}
                {onCancel && (
                    <DefaultButton className={styles.button} onClick={onCancel}>
                        {loc(cancelButton)}
                    </DefaultButton>
                )}
            </div>
        </div>
    );
});
